export function AccountBalances(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/account-balances`;
}

export function BalanceReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/balance`;
}

export function BalanceReportExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/balance/export`;
}

export function DeleteSplashScreenImage(organizationID: number): string {
	return `/v1/organizations/${organizationID}/splash-screen/image`;
}

export function ExportUsers(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/export`;
}

export function FritidskortetReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/fritidskortet`;
}

export function InternalApplyPaymentRate(organizationID: number): string {
	return `/v1/internal/organizations/${organizationID}/payment-rate`;
}

export function InternalList(): string {
	return `/v1/internal/organizations`;
}

export function InvoiceStatistics(organizationID: number): string {
	return `/v1/organizations/${organizationID}/invoice-statistics`;
}

export function InvoiceSummary(organizationID: number): string {
	return `/v1/organizations/${organizationID}/invoice-summary`;
}

export function ListGroupPosts(organizationID: number): string {
	return `/v1/organizations/${organizationID}/group-posts`;
}

export function ListOpenForms(organizationID: number): string {
	return `/v1/organizations/${organizationID}/forms/open-forms`;
}

export function ListPayouts(organizationID: number): string {
	return `/v1/organizations/${organizationID}/payouts/stripe`;
}

export function ListPublicFormCategories(organizationID: number): string {
	return `/v1/organizations/${organizationID}/form-categories/list-public`;
}

export function ListUsers(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users`;
}

export function ManagementDashboard(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/management`;
}

export function NetworkAttendanceReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/attendance-report`;
}

export function NetworkAttendanceReportExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/attendance-report/export`;
}

export function NetworkClubAttendanceReport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/attendance-report`;
}

export function NetworkClubAttendanceReportExport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/attendance-report/export`;
}

export function NetworkClubMembers(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/members`;
}

export function NetworkClubMembersExport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/members/export`;
}

export function NetworkClubPayments(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/payments`;
}

export function NetworkClubPaymentsReport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/payments-report`;
}

export function NetworkClubPaymentsReportExport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/payments-report/export`;
}

export function NetworkClubRegistrations(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/registrations`;
}

export function NetworkClubRegistrationsReport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/registrations-report`;
}

export function NetworkClubRegistrationsReportExport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/registrations-report/export`;
}

export function NetworkClubSummary(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/summary`;
}

export function NetworkClubSummaryExport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/summary/export`;
}

export function NetworkClubTeam(organizationID: number, clubID: string, teamID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/teams/${teamID}`;
}

export function NetworkClubTrainingReport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/training-report`;
}

export function NetworkClubTrainingReportExport(organizationID: number, clubID: string): string {
	return `/v1/organizations/${organizationID}/network/clubs/${clubID}/training-report/export`;
}

export function NetworkMembers(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/members`;
}

export function NetworkMembersReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/members-report`;
}

export function NetworkMembersReportExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/members-report/export`;
}

export function NetworkOverview(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/overview`;
}

export function NetworkOverviewExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/overview/export`;
}

export function NetworkPayments(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/payments`;
}

export function NetworkPaymentsReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/payments-report`;
}

export function NetworkPaymentsReportExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/payments-report/export`;
}

export function NetworkPost(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/network/posts/${postID}`;
}

export function NetworkPostAudience(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/post-audience`;
}

export function NetworkPostReach(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/post-reach`;
}

export function NetworkPosts(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/posts`;
}

export function NetworkRegistrations(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/registrations`;
}

export function NetworkRegistrationsReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/registrations-report`;
}

export function NetworkRegistrationsReportExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/registrations-report/export`;
}

export function NetworkTrainingReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/training-report`;
}

export function NetworkTrainingReportExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/network/training-report/export`;
}

export function OrganizationLinksIndex(organizationID: number): string {
	return `/v1/organizations/${organizationID}/links`;
}

export function PaymentDashboard(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/payments`;
}

export function PublicListForms(slug: string): string {
	return `/v1/organizations/public/${slug}/forms`;
}

export function RevenueReport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/revenue`;
}

export function RevenueReportExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/dashboards/revenue/export`;
}

export function Show(organizationID: number): string {
	return `/v1/organizations/${organizationID}`;
}

export function UpdateLOKSettings(organizationID: number): string {
	return `/v1/organizations/${organizationID}/lok-settings`;
}

export function UpdateSplashScreen(organizationID: number): string {
	return `/v1/organizations/${organizationID}/splash-screen`;
}

